import { Button, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Routes } from 'constants/routes.constants';

import SaudiRewardsEarnedPointsBanner from 'components/@saudi-rewards/SaudiRewardsEarnedPointsBanner';
import StickyButtonContainer from 'components/@saudi-rewards/SaudiRewardsRetroRedeemContainer/StickyButtonContainer';

const Confirmation = () => {
  return (
    <Stack sx={{ flexGrow: 1 }}>
      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
        <FormattedMessage id="claim.points.confirmation.title" />
      </Typography>
      <Typography variant="small" sx={{ mb: 3 }}>
        <FormattedMessage id="claim.points.confirmation.description" />
      </Typography>
      <Stack sx={{ flexGrow: { xs: 1, md: 0 }, zIndex: 1 }}>
        <SaudiRewardsEarnedPointsBanner />
      </Stack>
      <StickyButtonContainer>
        <Button
          href={Routes.AccountDetails}
          variant="outlined"
          color="secondary"
          sx={{ width: { xs: '100%', md: 'fit-content' } }}
        >
          <FormattedMessage id="claim.points.confirmation.button" />
        </Button>
      </StickyButtonContainer>
    </Stack>
  );
};

export default Confirmation;
